import { useState } from "react";

import { NY_AREA_BOUNDS } from "../constants/srpFullMap";
import { deepEqual } from "./clusterHelpers";

const useBounds = (lat, long) => {
  const [center, setCenter] = useState({
    northSouthLat: lat,
    eastWestLng: long
  });
  const [bounds, setBounds] = useState(NY_AREA_BOUNDS);

  const setMapBounds = props => {
    if (!deepEqual(bounds, props.bounds)) {
      setBounds(props.bounds);
    }

    if (!deepEqual(center, props.center)) {
      setCenter(props.center);
    }
  };

  return [bounds, center, setMapBounds];
};

const useZoom = (maxZoom, minZoom, zoomLevel) => {
  const [zoom, setZoom] = useState(zoomLevel);

  const handleZoomIn = () => {
    if (zoom < maxZoom) {
      setZoom(zoom + 1);
    }
  };

  const handleZoomOut = () => {
    if (zoom > minZoom) {
      setZoom(zoom - 1);
    }
  };

  const onZoomChanged = internalZoom => {
    setZoom(internalZoom);
  };

  return [zoom, handleZoomIn, handleZoomOut, onZoomChanged];
};

export { useBounds, useZoom };
